import useScopedTranslation from 'hooks/useScopedTranslation';
import { calendarComponentI18n } from '../i18n';
import '../CalendarItemDetail/calendarItemDetail.scss';

const priorityClassMap = {
  high: 'calendar-task--priority-high',
  medium: 'calendar-task--priority-medium',
  low: 'calendar-task--priority-low',
  none: 'calendar-task--priority-none',
};

const priorityKeyMap = {
  high: 'item_priority_high',
  medium: 'item_priority_medium',
  low: 'item_priority_low',
  none: 'item_priority_none',
};

const CalendarItem = ({ title, priority }) => {
  const { t } = useScopedTranslation(calendarComponentI18n);

  const priorityClass = priorityClassMap[priority] || '';
  const priorityLabel = priorityKeyMap[priority] ? t(priorityKeyMap[priority]) : '';

  return (
    <div className={`calendar-task-item ${priorityClass}`} title={title}>
      <div className='calendar-task-item__header'>
        <span
          className='calendar-task-item__priority-dot'
          aria-label={priorityLabel}
        />
        <span className='calendar-task-item__title'>{title}</span>
      </div>
    </div>
  );
};
export default CalendarItem;
